var gumshoe = require('../vendor/gumshoe');
import 'element-closest';
import * as Stickyfill from 'stickyfilljs';

export class ScrollspyNav {
    constructor() {

        if (document.querySelector('.scrollspy-nav')) {
            let navContainer = document.querySelectorAll('.scrollspy-nav')[0];

            if (navContainer.querySelector('.top-trigger')) {
                let jumpToTop = navContainer.querySelectorAll('.top-trigger')[0];

                jumpToTop.addEventListener('click', function (e) {
                    e.preventDefault();

                    if (history.pushState) {
                        history.pushState(null, null, '#top');
                    } else {
                        location.hash = '#top';
                    }

                    window.scrollTo(0, 0);
                });
            };

            // Find all sections to add to scrollspy nav list
            const jumpSections = Array.prototype.slice.call(document.querySelectorAll('[data-scrollspy="true"]'));
            let jumpList = '';

            // Create list item by looping through each section
            jumpSections.forEach(section => {
                let sectionTitle = section.innerHTML;
                let sectionContainer = section.closest('.layout-section');
                let sectionTarget = sectionContainer.id;

                jumpList += `<li><a href="#${sectionTarget}">${sectionTitle}</a></li>`;
            });

            // Add string of list items to scrollspy nav
            const jumpListContainer = navContainer.querySelectorAll('nav ul')[0];
            jumpListContainer.innerHTML = jumpList;

            // Handler when the DOM is fully loaded
            document.addEventListener("DOMContentLoaded", function () {
                gumshoe.init({
                    selector: '.scrollspy-nav a', // Default link selector (must use a valid CSS selector)
                    //selectorHeader: '#siteHeader', // Fixed header selector (must use a valid CSS selector)
                    container: window, // The element to spy on scrolling in (must be a valid DOM Node)
                    offset: 200, // Distance in pixels to offset calculations
                    activeClass: 'active', // Class to apply to active navigation link and its parent list item
                    scrollDelay: false // Wait until scrolling has stopped before updating the navigation
                });
            });

            // Setup sticky polyfill to sticky container element
            const stickyRail = navContainer.parentElement;
            Stickyfill.add(stickyRail);

            const footer = document.querySelector(".site-container > .footer");
            const siteContainer = document.querySelector('.site-container');
            const viewHeight = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
            let lastScrollTop = 0;
            let navOffset = stickyRail.getBoundingClientRect();

            if (window.matchMedia("(max-width: 64rem)").matches) {
                let stickyMobileTrigger = stickyRail.querySelector('.rail-nav-mobile-trigger');
                let stickyMobileNav = stickyRail.querySelector('.rail-nav');
                let stickyMobileNavContent = stickyMobileNav.querySelector('ul');
                
                stickyMobileTrigger.addEventListener('click', function(e) {
                    e.stopPropagation();
                    //stickyMobileNavContent.classList.add('visible');
                    stickyMobileNavContent.classList.add('visible');
                });

                // For clicks elsewhere on the page
                document.addEventListener('click', function () {
                    //close stuff
                    if (stickyMobileNavContent.classList.contains('visible')) {
                        stickyMobileNavContent.classList.remove('visible')
                    }
                });

                // For clicks elsewhere on the page
                document.addEventListener('touchstart', function () {
                    //close stuff
                    if (stickyMobileNavContent.classList.contains('visible')) {
                        stickyMobileNavContent.classList.remove('visible')
                    }
                });

        
                window.addEventListener("scroll", () =>
                    window.requestAnimationFrame(() => {
                        var currentPos = window.pageYOffset || document.documentElement.scrollTop; // Credits: "https://github.com/qeremy/so/blob/master/so.dom.js#L426"

                        if (currentPos >= 200 && !stickyMobileNav.classList.contains('visible')) {
                            stickyMobileNav.classList.add('visible');
                        } else if (currentPos < 200 && stickyMobileNav.classList.contains('visible')) {
                            stickyMobileNav.classList.remove('visible');
                        }
                   })
                );
            };

        };
    };
};


// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./Static/javascript/modules/scrollspy-nav.ts